(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(95369);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _404; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
;// CONCATENATED MODULE: ./components/images/NotFoundImage/notFoundImage.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 8rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const Image = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("svg", {
    target: "e68fohe0"
})("margin-top:4rem;flex:0 0 100%;", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";");

;// CONCATENATED MODULE: ./components/images/NotFoundImage/NotFoundImage.tsx


const NotFoundImage = ()=>{
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Image, {
        width: "1170",
        viewBox: "0 0 1170 299",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M371.326 9.11684L239.119 200.352L239.086 200.403C235.882 205.355 234 210.286 234 215.1C234 220.129 235.719 224.536 239.212 228.028C242.846 231.662 247.747 233.24 253.352 233.24H368.936V276.104V295H0V299H373V295.052V295V276.104V229.24H253.352C248.504 229.24 244.733 227.893 242.04 225.2C239.347 222.507 238 219.14 238 215.1C238 211.329 239.481 207.155 242.444 202.576L374.552 11.4839C378.323 6.63591 383.171 4.21191 389.096 4.21191C393.675 4.21191 397.58 5.69324 400.812 8.65591C404.044 11.6186 405.66 15.7933 405.66 21.1799V201.768H435.96C440.808 201.768 444.579 203.115 447.272 205.808C449.965 208.232 451.312 211.464 451.312 215.504C451.312 224.661 446.195 229.24 435.96 229.24H406V276.104V295V295.052V299H528H530.635H537.466C528.761 293.162 521.183 285.534 514.734 276.116C497.766 251.337 489.282 215.247 489.282 167.844C489.282 120.172 497.766 83.9466 514.734 59.1679C531.702 34.3892 556.481 21.9999 589.07 21.9999C621.66 21.9999 646.438 34.3892 663.406 59.1679C680.374 83.6772 688.858 119.768 688.858 167.44C688.858 215.112 680.374 251.337 663.406 276.116C656.957 285.534 649.38 293.162 640.674 299H647.505H675H857V295V276.104V229.24H737.836C732.988 229.24 729.218 227.893 726.524 225.2C723.831 222.507 722.484 219.14 722.484 215.1C722.484 211.329 723.966 207.155 726.928 202.576L859.036 11.4839C862.807 6.63591 867.655 4.21191 873.58 4.21191C878.159 4.21191 882.064 5.69324 885.296 8.65591C888.528 11.6186 890.144 15.7933 890.144 21.1799V201.768H920.444C925.292 201.768 929.063 203.115 931.756 205.808C934.45 208.232 935.796 211.464 935.796 215.504C935.796 224.661 930.679 229.24 920.444 229.24H890V276.104V295V299H1170V295H894.144V276.104V233.24H920.444C926.075 233.24 931.046 231.99 934.626 228.787C938.29 225.508 939.796 220.821 939.796 215.504C939.796 210.511 938.095 206.171 934.51 202.905C930.883 199.324 926.011 197.768 920.444 197.768H894.144V21.1799C894.144 14.9481 892.241 9.59598 887.999 5.70729C883.994 2.03614 879.111 0.211914 873.58 0.211914C866.369 0.211914 860.375 3.24728 855.879 9.02816L855.81 9.11684L723.603 200.352L723.57 200.403C720.366 205.355 718.484 210.286 718.484 215.1C718.484 220.129 720.203 224.536 723.696 228.028C727.33 231.662 732.231 233.24 737.836 233.24H853.42V276.104V295H652.283C657.575 290.227 662.385 284.686 666.707 278.376C684.326 252.645 692.858 215.483 692.858 167.44C692.858 119.409 684.331 82.3721 666.703 56.9022C648.917 30.9335 622.844 17.9999 589.07 17.9999C555.293 17.9999 529.219 30.9354 511.434 56.9079C493.814 82.6385 485.282 119.801 485.282 167.844C485.282 215.623 493.816 252.648 511.434 278.376C515.755 284.686 520.566 290.227 525.857 295H409.66V276.104V233.24H435.96C441.591 233.24 446.561 231.99 450.141 228.787C453.806 225.508 455.312 220.821 455.312 215.504C455.312 210.511 453.611 206.172 450.026 202.905C446.399 199.324 441.527 197.768 435.96 197.768H409.66V21.1799C409.66 14.9481 407.757 9.59598 403.515 5.70729C399.51 2.03614 394.627 0.211914 389.096 0.211914C381.885 0.211914 375.891 3.24728 371.395 9.02816L371.326 9.11684ZM275.572 201.768H372.936V61.5799L275.572 201.768ZM283.22 197.768L368.936 74.3514V197.768H283.22ZM635.672 80.1027L635.682 80.1217L635.693 80.1405C645.934 98.0625 651.326 126.956 651.326 167.44C651.326 207.642 645.938 236.554 635.681 254.761C625.643 272.578 610.305 281.408 589.07 281.408C567.835 281.408 552.497 272.578 542.459 254.761C532.202 236.554 526.814 207.642 526.814 167.44C526.814 127.231 532.204 98.4692 542.447 80.5445L542.453 80.5339L542.459 80.5233C552.497 62.7061 567.835 53.8759 589.07 53.8759C599.961 53.8759 609.155 56.1147 616.798 60.4292C624.428 64.7368 630.732 71.2363 635.672 80.1027ZM760.056 201.768H857.42V61.5799L760.056 201.768ZM767.705 197.768L853.42 74.3515V197.768H767.705ZM589.07 285.408C611.694 285.408 628.393 275.847 639.166 256.724C649.94 237.601 655.326 207.84 655.326 167.44C655.326 126.771 649.94 97.0093 639.166 78.1559C628.662 59.3026 611.964 49.8759 589.07 49.8759C566.446 49.8759 549.748 59.4372 538.974 78.5599C528.201 97.4133 522.814 127.04 522.814 167.44C522.814 207.84 528.201 237.601 538.974 256.724C549.748 275.847 566.446 285.408 589.07 285.408Z",
                fill: "url(#paint0_linear)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                    id: "paint0_linear",
                    x1: "267.606",
                    y1: "665.371",
                    x2: "802.648",
                    y2: "-209.583",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            stopColor: "#0E4ED7"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "1",
                            stopColor: "#F94743"
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/images/NotFoundImage/index.ts

/* harmony default export */ var images_NotFoundImage = (NotFoundImage);

// EXTERNAL MODULE: ./models/enums/routes.ts
var routes = __webpack_require__(20365);
// EXTERNAL MODULE: ./styles/pages/styled/error.styles.tsx
var error_styles = __webpack_require__(90897);
;// CONCATENATED MODULE: ./pages/404.tsx






const NotFound = (param)=>{
    let { data: { page  }  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(error_styles/* Wrapper */.im, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(images_NotFoundImage, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(error_styles/* ErrorMessage */.Bc, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(error_styles/* Text */.xv, {
                    children: prismic_reactjs.RichText.asText(page.title)
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                href: routes/* Routes.Home */.Z.Home,
                legacyBehavior: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(error_styles/* ActionButton */.Kk, {
                    children: prismic_reactjs.RichText.asText(page.action)
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _404 = (NotFound);


/***/ }),

/***/ 90897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bc": function() { return /* binding */ ErrorMessage; },
/* harmony export */   "Kk": function() { return /* binding */ ActionButton; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "jw": function() { return /* binding */ ErrorSpace; },
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16829);
/* harmony import */ var _mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8066);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin-top: 3rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin-top: 6rem;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: block;\n    text-align: center;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: inline;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-size: 1.875rem;\n    line-height: 3rem;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: auto;\n    display: inline;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}



const Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "emj54tm0"
})(_mixins__WEBPACK_IMPORTED_MODULE_2__/* .defaultContainerSize */ .sX, ";display:flex;flex-wrap:wrap;align-items:center;justify-content:center;position:relative;z-index:0;");
const ActionButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("a", {
    target: "emj54tm1"
})("cursor:pointer;margin-top:2.5rem;font-size:1.25rem;line-height:2rem;border-radius:4rem;padding:0.75rem 2.5rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";box-shadow:inset 0 0 0 0.0625rem ", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";text-decoration:none;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_black;
}, ";position:relative;transition:background-color 200ms ease-in-out,box-shadow 200ms ease-in-out;&:before{content:'';z-index:-1;width:100%;height:100%;position:absolute;left:0;top:0;border-radius:4rem;background:linear-gradient(\n      88.48deg,#0f4ed7 0%,#684b9f 59.57%,#d2485c 98.61%\n    );}&:hover{background-color:transparent;box-shadow:none;}", _mixins__WEBPACK_IMPORTED_MODULE_2__.mq.small((0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject())), ";");
const ErrorMessage = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "emj54tm2"
})("margin:2.5rem 0 0 0;flex:0 0 100%;display:flex;justify-content:center;align-items:center;flex-wrap:wrap;", _mixins__WEBPACK_IMPORTED_MODULE_2__.mq.small((0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1())), ";", _mixins__WEBPACK_IMPORTED_MODULE_2__.mq.xLarge((0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2())), ";");
const ErrorSpace = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "emj54tm3"
})("display:none;", _mixins__WEBPACK_IMPORTED_MODULE_2__.mq.xLarge((0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3())), ";");
const Text = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("p", {
    target: "emj54tm4"
})("color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";margin:0;font-size:1.25rem;font-weight:400;line-height:2rem;flex:0 0 100%;text-align:center;", _mixins__WEBPACK_IMPORTED_MODULE_2__.mq.small((0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4())), ";", _mixins__WEBPACK_IMPORTED_MODULE_2__.mq.xLarge((0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject5())), ";");


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);